import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		centeredCell: {
			display: "flex",
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
		},
		reactTable: {
			"& .rt-tr-group .delete": {
				visibility: "hidden",
			},
			"& .rt-tr-group:hover .delete": {
				visibility: "visible",
			},
			"& .-pagination": {
				"& .-pageJump": {
					display: "none",
				},
				"& .-totalPages": {
					display: "none",
				}
			},

		},
		dialogText: {
			paddingTop: 5,
			color: theme.palette.primary.main,
		},
		dialogContent: {
			[theme.breakpoints.down("xs")]: {
				display: "flex",
				alignItems: "flex-end",
				textAlign: "center",
			},
		},
		dialogActions: {
			[theme.breakpoints.down("xs")]: {
				height: "50%",
				justifyContent: "center",
				alignItems: "flex-start",
				paddingLeft: 30,
				paddingRight: 30,
				"& button": {
					flex: 1,
				},
			},
		},
		formControl: {
			minWidth: 200,

		},
		link: {
			"&:hover": {
				cursor: "pointer",
			}
		},
		tagChip: {
			margin: 2,
		},
	} satisfies Record<string, CSSObject>;
};
